export default __webpack_public_path__ + "static/media/necklace.f5ed1d67.png";